import Form from "../../ui/Form";
import Modal from "../../ui/Modal";
import { printDate } from "../../utils/date.utils";
import {
  getAllPaymentType,
  getPaymentTypeById,
  useCreateCustomerPaymentMutation,
  useUpdateCustomerPaymentMutation
} from "../../utils/customerPayment.utils";
import PaymentAmountField from "./PaymentAmountField";

export default function PaymentAddEdit({ modal, toggle, editItem, customer_attachment_id, due }) {
  const id = editItem?.id ?? "";

  const paymentTypes = getAllPaymentType();
  const { loading, createCustomerPayment } = useCreateCustomerPaymentMutation([
    "createCustomerPayment"
  ]);

  const { loading: updating, updateCustomerPayment } = useUpdateCustomerPaymentMutation([
    "updateCustomerPayment"
  ]);

  const fields = [
    {
      label: "Payment Date",
      name: "payment_date",
      type: "date",
      placeholder: "Select a date",
      col: { md: 12 }
    },
    {
      label: "Payment Made",
      name: "payment_type_id",
      type: "select",
      placeholder: "Select a payment type",
      col: { md: 12 },
      rules: { required: "This is required field!" },
      options: paymentTypes,
      isClearable: false
    },
    {
      name: "PaymentAmountField",
      type: "custom",
      customComponent: PaymentAmountField,
      col: { md: 12 },
      others: { due }
    },
    {
      label: "Remarks",
      name: "remarks",
      type: "textarea",
      placeholder: "Remarks",
      col: { md: 12 }
      // rules: { required: "This is required field!" }
    }
  ];

  const defaultValues = {
    payment_date: editItem?.payment_date
      ? printDate(new Date(editItem?.payment_date))
      : printDate(new Date()),
    payment_type_id: editItem?.payment_type_id ? getPaymentTypeById(editItem?.payment_type_id) : "",
    amount: editItem?.amount ?? "",
    remarks: editItem?.remarks ?? ""
  };

  const onSubmit = async (data) => {
    const payment_date = data?.payment_date ? printDate(data?.payment_date) : "";
    const payment_type_id = data?.payment_type_id?.value ?? "";
    const amount = data?.amount ? Number(data?.amount) : 0;
    const remarks = data?.remarks ?? "";

    const values = {
      payment_date,
      payment_type_id,
      amount,
      remarks,
      customer_attachment_id
    };

    if (!!id) {
      const afterUpdated = await updateCustomerPayment({ id, ...values });

      if (afterUpdated?.status === 200) {
        toggle();
      }
      return;
    }

    const afterCreated = await createCustomerPayment({ ...values });
    if (afterCreated?.status === 201) {
      toggle();
    }
  };

  const isLoading = loading || updating;

  const title = `${!!id ? "Edit" : "Add"} Payment`;

  return (
    <Modal modal={modal} toggle={toggle} title={title}>
      <Form
        fields={fields}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        submitbtnText={isLoading ? `${!!id ? "Updating..." : "Creating...."}` : title}
        toggle={toggle}
        loading={typeof isLoading === "boolean" ? isLoading : undefined}
      />
    </Modal>
  );
}
